module.exports = __webpack_public_path__ + "img/like.4f9d50f.png";